import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class KatKullanimListeAPI extends BaseAPI {


  constructor () {
    const baseUrl = environment.API_URL + "KatKullanimListe";
    super(baseUrl);
  }


  getKatKullanimListe( katKullanimSekliKodu?: number){
    var request= new KatKullanimListeRequest( katKullanimSekliKodu);

    return this.post("",request);
  }

}


export default new KatKullanimListeAPI();
class KatKullanimListeRequest {
  public katKullanimSekliKodu?: number;


  constructor(katKullanimSekliKodu?: number) {

      this.katKullanimSekliKodu = katKullanimSekliKodu;


  }
}
export { KatKullanimListeRequest };
